import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

/** Voegt een artikel uit "Anderen kochten ook" toe zonder de slide cart te sluiten. */
async function addUpsell(button) {
  const card = button.closest('.nm-upsell__card');
  const variantId = card?.querySelector('.nm-upsell__select')?.value;
  if (!variantId) return;

  button.disabled = true;
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((component) => component.dataset.sectionId)
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  // Vanaf body versturen: de cart-items-component ververst zich dan zelf met de meegegeven secties.
  document.body.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const body = JSON.stringify({ id: Number(variantId), quantity: 1, sections: sectionIds.join(',') });
    const response = await fetch(Theme.routes.cart_add_url, { ...fetchConfig('json', { body }) });
    const result = await response.json();
    if (result.status) throw new Error(result.description || result.message);

    const cart = await fetch(`${Theme.routes.cart_url}.js`).then((res) => res.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'nm-upsell',
        itemCount: 1,
        sections: result.sections,
        didError: false,
      },
    });
  } catch (error) {
    deferred.reject(error);
    document.body.dispatchEvent(
      new CartErrorEvent({ error: error?.message || 'Toevoegen is niet gelukt', code: 'INVALID' })
    );
    button.disabled = false;
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const addButton = target.closest('[data-nm-upsell-add]');
  if (addButton) {
    addUpsell(addButton);
    return;
  }

  const arrow = target.closest('[data-nm-upsell-scroll]');
  if (arrow) {
    const track = arrow.closest('.nm-upsell')?.querySelector('[data-nm-upsell-track]');
    track?.scrollBy({ left: Number(arrow.dataset.nmUpsellScroll) * track.clientWidth * 0.85, behavior: 'smooth' });
  }
});
